import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  TableHeader: {
    '& th': {
      fontWeight: 600,
      background: '#F9FAFB',
      fontSize: '12px',
      lineHeight: '18px',
      color: '#475467',
      padding: '0',
      borderBottom: '1px solid #EAECF0',
    },
    '& .MuiTableSortLabel-root': {
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '18px',
      color: '#475467',
      '&:hover': {
        color: '#101828',
      },
      '&.Mui-active': {
        color: '#101828',
        '& .MuiTableSortLabel-icon': {
          color: '#101828',
          opacity: 1,
        },
      },
    },
    '& .MuiTableSortLabel-icon': {
      fontSize: '16px',
      opacity: 0.5,
      marginLeft: '4px',
    },
  },
}));

export { useStyles };
